import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
const pdfjsLib = require("pdfjs-dist/build/pdf.js");
const pdfjsWorkerUrl = require("file-loader?name=pdf.worker.js&publicPath=/!pdfjs-dist/build/pdf.worker.js");

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorkerUrl;

declare var ko: any;
declare var require: any;

const BAH_GRADE_KEYS = [
    "E01", "E02", "E03", "E04", "E05", "E06", "E07", "E08", "E09",
    "W01", "W02", "W03", "W04", "W05", "O01E", "O02E", "O03E",
    "O01", "O02", "O03", "O04", "O05", "O06", "O07", "O08", "O09", "O10"
];

const BAH_HEADER_KEYS: Record<string, string> = {
    "E-1": "E01", "E-2": "E02", "E-3": "E03", "E-4": "E04", "E-5": "E05", "E-6": "E06", "E-7": "E07", "E-8": "E08", "E-9": "E09",
    "W-1": "W01", "W-2": "W02", "W-3": "W03", "W-4": "W04", "W-5": "W05",
    "O-1E": "O01E", "O-2E": "O02E", "O-3E": "O03E",
    "O-1": "O01", "O-2": "O02", "O-3": "O03", "O-4": "O04", "O-5": "O05", "O-6": "O06", "O-7": "O07", "O-8": "O08", "O-9": "O09", "O-10": "O10"
};

export class militaryBahCalculator_template extends vnTemplate {
    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="milpay-calculator">
                <div class="form-header">
                    <h2>Military BAH Calculator Builder</h2>
                    <span data-bind="text: statusText" class="milpay-status-text"></span>
                </div>
                <div class="form-body">
                    <h3>Data File Uploads</h3>
                    <p style="color:#6c757d;margin-bottom:1.5rem;font-size:.95rem;">Upload the two annual DoD BAH-rate PDFs. The importer merges their MHA rows and validates every published pay-grade value before it can be saved.</p>
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div><strong>With Dependents PDF</strong><p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Official annual BAH table for members with dependents.</p></div>
                            <div style="display:flex;align-items:center;gap:.75rem;"><span data-bind="text: withDependantsStatus, css: {'milpay-status-ok': withDependantsStatus() === 'Parsed', 'milpay-status-pending': withDependantsStatus() === 'Not Uploaded', 'milpay-status-error': withDependantsStatus() === 'Error'}" class="milpay-status"></span><label class="milpay-upload-btn">Choose PDF<input type="file" accept="application/pdf,.pdf" style="display:none;" data-bind="event: {change: handleWithDependantsUpload}" /></label></div>
                        </div>
                        <div data-bind="visible: withDependantsFileName" style="font-size:.9rem;color:#555;margin-top:.5rem;">Uploaded: <span data-bind="text: withDependantsFileName"></span></div>
                        <div data-bind="visible: withDependantsCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;"><span data-bind="text: withDependantsCount"></span> military housing areas parsed.</div>
                    </div>
                    <div class="milpay-upload-card">
                        <div class="milpay-upload-row">
                            <div><strong>Without Dependents PDF</strong><p style="margin:.25rem 0 0;font-size:.95rem;color:#555;">Official annual BAH table for members without dependents.</p></div>
                            <div style="display:flex;align-items:center;gap:.75rem;"><span data-bind="text: withoutDependantsStatus, css: {'milpay-status-ok': withoutDependantsStatus() === 'Parsed', 'milpay-status-pending': withoutDependantsStatus() === 'Not Uploaded', 'milpay-status-error': withoutDependantsStatus() === 'Error'}" class="milpay-status"></span><label class="milpay-upload-btn">Choose PDF<input type="file" accept="application/pdf,.pdf" style="display:none;" data-bind="event: {change: handleWithoutDependantsUpload}" /></label></div>
                        </div>
                        <div data-bind="visible: withoutDependantsFileName" style="font-size:.9rem;color:#555;margin-top:.5rem;">Uploaded: <span data-bind="text: withoutDependantsFileName"></span></div>
                        <div data-bind="visible: withoutDependantsCount() > 0" style="font-size:.95rem;color:#28a745;margin-top:.5rem;"><span data-bind="text: withoutDependantsCount"></span> military housing areas parsed.</div>
                    </div>
                    <div class="milpay-section">
                        <h3 class="milpay-section-title">Release Settings</h3>
                        <div class="milpay-field-grid">
                            <div class="milpay-field"><label class="form-label">BAH Rate Year</label><input type="number" class="form-control" data-bind="value: bahRateYear, event: { wheel: function(_, event) { event.preventDefault(); return false; } }" /></div>
                        </div>
                    </div>
                    <div style="display:flex;gap:1rem;margin-top:1.5rem;"><button class="w-btn w-btn-primary" style="padding:.75rem 2rem;font-size:1rem;" data-bind="click: generateJson">Generate JSON</button><button class="w-btn" style="padding:.75rem 2rem;font-size:1rem;" data-bind="click: save, enable: generatedJson">Save</button></div>
                    <div data-bind="visible: jsonPreview" style="margin-top:1.5rem;"><h3>Payload Preview</h3><pre data-bind="text: jsonPreview" style="max-height:400px;overflow:auto;"></pre></div>
                </div>
            </div>

            <style>
                .milpay-calculator {
                    --milpay-primary: #2563eb;
                    --milpay-primary-hover: #1d4ed8;
                    --milpay-border: #e5e7eb;
                    --milpay-border-focus: #2563eb;
                    --milpay-bg-section: #fafbfc;
                    --milpay-text: #1f2937;
                    --milpay-text-muted: #6b7280;
                    --milpay-success: #059669;
                    --milpay-warn: #d97706;
                    --milpay-error: #dc2626;
                    --milpay-radius: 8px;
                    --milpay-radius-sm: 6px;
                    background: #fff;
                    border-radius: var(--milpay-radius);
                    box-shadow: 0 1px 3px rgba(0,0,0,.08);
                    color: var(--milpay-text);
                    overflow: hidden;
                }
                .milpay-calculator .form-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 1.25rem 1.5rem;
                    border-bottom: 1px solid var(--milpay-border);
                }
                .milpay-calculator .form-header h2 { margin: 0; font-size: 1.35rem; font-weight: 600; }
                .milpay-status-text { color: var(--milpay-text-muted); font-size: .95rem; }
                .milpay-calculator .form-body { padding: 1.5rem 1.75rem; }
                .milpay-calculator .form-body > h3 { margin-top: 0; }
                .milpay-upload-card {
                    margin-bottom: .85rem;
                    padding: 1.15rem 1.35rem;
                    background: #fff;
                    border: 1px solid var(--milpay-border);
                    border-radius: var(--milpay-radius);
                    box-shadow: 0 1px 3px rgba(0,0,0,.08);
                }
                .milpay-upload-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 1rem;
                    text-align: left;
                }
                .milpay-upload-btn {
                    display: inline-block;
                    padding: .55rem 1.25rem;
                    background: var(--milpay-primary);
                    color: #fff;
                    border-radius: var(--milpay-radius-sm);
                    cursor: pointer;
                    font-size: .9rem;
                    font-weight: 500;
                    white-space: nowrap;
                }
                .milpay-upload-btn:hover, .milpay-calculator .w-btn-primary:hover { background: var(--milpay-primary-hover); }
                .milpay-status {
                    padding: .3rem .75rem;
                    border: 1px solid transparent;
                    border-radius: 9999px;
                    font-size: .85rem;
                    font-weight: 600;
                    white-space: nowrap;
                }
                .milpay-status-ok { background: rgba(5,150,105,.12); color: var(--milpay-success); border-color: rgba(5,150,105,.25); }
                .milpay-status-pending { background: rgba(217,119,6,.12); color: var(--milpay-warn); border-color: rgba(217,119,6,.25); }
                .milpay-status-error { background: rgba(220,38,38,.12); color: var(--milpay-error); border-color: rgba(220,38,38,.25); }
                .milpay-section {
                    margin: 1.35rem 0;
                    padding: 1.15rem 1.35rem;
                    background: var(--milpay-bg-section);
                    border: 1px solid var(--milpay-border);
                    border-radius: var(--milpay-radius);
                    box-shadow: 0 1px 3px rgba(0,0,0,.08);
                }
                .milpay-section-title {
                    margin: 0 0 .75rem;
                    padding-bottom: .5rem;
                    border-bottom: 1px solid var(--milpay-border);
                    font-size: 1.05rem;
                    font-weight: 600;
                }
                .milpay-field-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: .85rem 1.35rem; }
                .milpay-field .form-label { display: block; margin-bottom: .35rem; font-size: .9rem; font-weight: 600; }
                .milpay-field .form-control {
                    box-sizing: border-box;
                    width: 100%;
                    padding: .55rem .85rem;
                    border: 1px solid var(--milpay-border);
                    border-radius: var(--milpay-radius-sm);
                    font-size: 1rem;
                }
                .milpay-field .form-control:focus { outline: none; border-color: var(--milpay-border-focus); box-shadow: 0 0 0 3px rgba(37,99,235,.15); }
                .milpay-calculator .w-btn {
                    padding: .65rem 1.5rem;
                    border: 1px solid var(--milpay-border);
                    border-radius: var(--milpay-radius-sm);
                    background: #fff;
                    cursor: pointer;
                    font-size: .95rem;
                    font-weight: 500;
                }
                .milpay-calculator .w-btn-primary { border-color: var(--milpay-primary); background: var(--milpay-primary); color: #fff; }
                .milpay-calculator .w-btn:disabled { cursor: not-allowed; opacity: .5; }
                @media (max-width: 700px) {
                    .milpay-upload-row { align-items: flex-start; flex-direction: column; }
                    .milpay-field-grid { grid-template-columns: 1fr; }
                }
            </style>`;
    }

    protected buildViewModel(): any {
        const self = this;
        const saveStatus = ko.observable("");
        return {
            statusText: ko.pureComputed(function () { return saveStatus(); }),
            saveStatus: saveStatus,
            withDependantsStatus: ko.observable("Not Uploaded"),
            withoutDependantsStatus: ko.observable("Not Uploaded"),
            withDependantsCount: ko.observable(0),
            withoutDependantsCount: ko.observable(0),
            withDependantsFileName: ko.observable(""),
            withoutDependantsFileName: ko.observable(""),
            bahRateYear: ko.observable(""),
            housingAllowanceData: ko.observable({}),
            militaryHousingAreasData: ko.observable([]),
            generatedJson: ko.observable(null),
            jsonPreview: ko.observable(""),
            handleWithDependantsUpload: function (data: any, event: any) { self.handlePdfUpload(event, true); },
            handleWithoutDependantsUpload: function (data: any, event: any) { self.handlePdfUpload(event, false); },
            generateJson: function () { self.generateJson(); },
            save: function () { self.save(); }
        };
    }

    protected getTemplateName(): string { return "militaryBahCalculator_template"; }
    private vm(): any { return this.getTemplateViewModel(); }

    private withDependantsRates: Record<string, { name: string, rates: number[] }> = {};
    private withoutDependantsRates: Record<string, { name: string, rates: number[] }> = {};

    public async handlePdfUpload(event: any, withDependants: boolean): Promise<void> {
        const file = event.target.files[0];
        if (!file) return;
        const vm = this.vm();
        const status = withDependants ? vm.withDependantsStatus : vm.withoutDependantsStatus;
        const count = withDependants ? vm.withDependantsCount : vm.withoutDependantsCount;
        const fileName = withDependants ? vm.withDependantsFileName : vm.withoutDependantsFileName;
        status("Parsing...");
        try {
            const parsed = await this.parsePdf(await file.arrayBuffer());
            if (withDependants) this.withDependantsRates = parsed;
            else this.withoutDependantsRates = parsed;
            fileName(file.name);
            count(Object.keys(parsed).length);
            status("Parsed");
            vm.generatedJson(null);
            vm.jsonPreview("");
            this.mergePdfRates();
        } catch (error) {
            status("Error");
            alert("Unable to parse the BAH PDF: " + (error.message || error));
        }
    }

    private async parsePdf(data: ArrayBuffer): Promise<Record<string, { name: string, rates: number[] }>> {
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorkerUrl;

        const pdf = await pdfjsLib.getDocument({ data: new Uint8Array(data) }).promise;
        const parsed: Record<string, { name: string, rates: number[] }> = {};
        const pageItems: any[][] = [];
        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
            const content = await (await pdf.getPage(pageNumber)).getTextContent();
            pageItems.push(content.items);
            const rows: any[][] = [];
            content.items.forEach((item: any) => {
                const row = rows.find((candidate: any[]) => Math.abs(candidate[0].transform[5] - item.transform[5]) <= 1);
                if (row) row.push(item);
                else rows.push([item]);
            });
            rows.forEach((row) => {
                const rowItems = row.sort((a, b) => a.transform[4] - b.transform[4]).filter((item) => String(item.str).trim());
                const cells = rowItems.map((item) => String(item.str).trim());
                let rateItems = rowItems;
                let rateCells = cells.map((cell) => cell.replace(/[$,]/g, ""));
                let mha = cells.find((cell) => /^([A-Z]{2}\d{3})$/.test(cell));
                let mhaIndex = mha === undefined ? -1 : cells.indexOf(mha);
                let mhaCellCount = 1;

                // Some legacy PDFs split a code such as NY219 into two adjacent text items: N and Y219.
                if (mhaIndex === -1) {
                    const splitMhaIndex = cells.findIndex((cell, index) => /^[A-Z]$/.test(cell)
                        && /^[A-Z]\d{3}$/.test(cells[index + 1] || "")
                        && rowItems[index + 1].transform[4] - rowItems[index].transform[4] <= 10);
                    if (splitMhaIndex !== -1) {
                        mha = cells[splitMhaIndex] + cells[splitMhaIndex + 1];
                        mhaIndex = splitMhaIndex;
                        mhaCellCount = 2;
                    }
                }
                if (!mha || mhaIndex === -1) return;

                let minimumRateIndex = mhaIndex + mhaCellCount;
                let rateStart = rateCells.findIndex((cell, index) => index >= minimumRateIndex && /^\d{3,5}$/.test(cell));
                if (rateStart === -1) {
                    const rowY = row[0].transform[5];
                    const supplementalRow = rows
                        .filter((candidate: any[]) => candidate !== row
                            && candidate[0].transform[5] > rowY
                            && candidate[0].transform[5] - rowY <= 7)
                        .sort((a: any[], b: any[]) => a[0].transform[5] - b[0].transform[5])
                        .find((candidate: any[]) => candidate.filter((item) => /^\d{3,5}$/.test(String(item.str).trim())).length >= 20);
                    if (supplementalRow) {
                        rateItems = supplementalRow.sort((a, b) => a.transform[4] - b.transform[4]).filter((item) => String(item.str).trim());
                        rateCells = rateItems.map((item) => String(item.str).trim().replace(/[$,]/g, ""));
                        minimumRateIndex = 0;
                        rateStart = rateCells.findIndex((cell) => /^\d{3,5}$/.test(cell));
                    }
                }
                if (rateStart === -1) return;
                if (rateStart >= minimumRateIndex + 2) {
                    let fragmentedRateStart = rateStart;
                    while (fragmentedRateStart > minimumRateIndex
                        && /^\d{1,2}$/.test(rateCells[fragmentedRateStart - 1])
                        && rateItems[fragmentedRateStart].transform[4] - rateItems[fragmentedRateStart - 1].transform[4] <= 15) {
                        fragmentedRateStart--;
                    }
                    const fragmentedRate = rateCells.slice(fragmentedRateStart, rateStart).join("");
                    if (/^\d{3,5}$/.test(fragmentedRate)) rateStart = fragmentedRateStart;
                }
                const rateParts = rateItems.slice(rateStart).map((item) => ({
                    value: String(item.str).trim().replace(/[$,]/g, ""),
                    x: item.transform[4]
                })).filter((part) => /^\d{1,5}$/.test(part.value));
                const rateTokens: Array<{ value: string, x: number }> = [];
                rateParts.forEach((part) => {
                    const previous = rateTokens[rateTokens.length - 1];
                    if (previous && (previous.value.length < 3 || part.value.length < 3) && part.x - previous.x <= 15) {
                        previous.value += part.value;
                    } else rateTokens.push(part);
                });
                const rates = rateTokens.map((part) => part.value).filter((cell) => /^\d{3,5}$/.test(cell)).map(Number);
                if (rates.length === 23) rates.unshift(rates[0]);
                if (rates.length === 21 || rates.length === 22 || rates.length === 24 || rates.length === 27) {
                    parsed[mha] = {
                        name: rateItems === rowItems
                            ? (mhaIndex > 0 ? cells.slice(0, mhaIndex) : cells.slice(mhaIndex + mhaCellCount, rateStart)).join(" ") || mha
                            : mha,
                        rates: rates.length === 27
                            ? rates
                            : rates.length === 24
                                ? rates.concat([rates[23], rates[23], rates[23]])
                                : rates.length === 22
                                    ? rates.concat([rates[21], rates[21], rates[21], rates[21], rates[21]])
                                    : rates.concat([rates[20], rates[20], rates[20], rates[20], rates[20], rates[20]])
                    };
                }
            });
            this.parseLegacyPdfPage(content.items, parsed);
        }
        const rotatedParsed: Record<string, { name: string, rates: number[] }> = {};
        pageItems.forEach((items) => this.parseRotatedPdfPage(items, rotatedParsed));
        if (Object.keys(parsed).length < 250) {
            // A rotated source is a separate layout. Discard incomplete horizontal-layout
            // matches before using its complete rotated result.
            Object.keys(parsed).forEach((mha) => delete parsed[mha]);
            Object.keys(rotatedParsed).forEach((mha) => parsed[mha] = rotatedParsed[mha]);
        } else {
            // Some rotated documents produce enough horizontal matches to pass the fallback
            // threshold while still omitting columns. Preserve those matches and fill gaps.
            Object.keys(rotatedParsed).forEach((mha) => {
                if (!parsed[mha]) parsed[mha] = rotatedParsed[mha];
            });
        }
        if (Object.keys(parsed).length < 250) throw new Error("The PDF did not contain the expected MHA rate table");
        return parsed;
    }

    private parseLegacyPdfPage(items: any[], parsed: Record<string, { name: string, rates: number[] }>): void {
        const rawEntries = items.map((item: any) => ({
            text: String(item.str).trim(),
            x: item.transform[4],
            y: item.transform[5]
        })).filter((item: any) => item.text !== "");
        const consumedEntryIndexes: Record<number, boolean> = {};
        const entries = rawEntries.reduce((normalized: any[], entry: any, index: number) => {
            if (consumedEntryIndexes[index]) return normalized;

            if (/^[A-Z]$/.test(entry.text)) {
                const suffixIndex = rawEntries.findIndex((candidate: any, candidateIndex: number) => candidateIndex > index
                    && !consumedEntryIndexes[candidateIndex]
                    && /^[A-Z]\d{3}$/.test(candidate.text)
                    && Math.abs(candidate.x - entry.x) <= 2
                    && candidate.y > entry.y
                    && candidate.y - entry.y <= 6);
                if (suffixIndex !== -1) {
                    consumedEntryIndexes[suffixIndex] = true;
                    normalized.push({
                        text: entry.text + rawEntries[suffixIndex].text,
                        x: entry.x,
                        y: entry.y
                    });
                    return normalized;
                }

                const secondLetterIndex = rawEntries.findIndex((candidate: any, candidateIndex: number) => candidateIndex > index
                    && !consumedEntryIndexes[candidateIndex]
                    && /^[A-Z]$/.test(candidate.text)
                    && Math.abs(candidate.x - entry.x) <= 2
                    && candidate.y > entry.y
                    && candidate.y - entry.y <= 3);
                if (secondLetterIndex !== -1) {
                    const numberIndex = rawEntries.findIndex((candidate: any, candidateIndex: number) => candidateIndex > secondLetterIndex
                        && !consumedEntryIndexes[candidateIndex]
                        && /^\d{3}$/.test(candidate.text)
                        && Math.abs(candidate.x - entry.x) <= 2
                        && candidate.y > rawEntries[secondLetterIndex].y
                        && candidate.y - rawEntries[secondLetterIndex].y <= 6);
                    if (numberIndex !== -1) {
                        consumedEntryIndexes[secondLetterIndex] = true;
                        consumedEntryIndexes[numberIndex] = true;
                        normalized.push({
                            text: entry.text + rawEntries[secondLetterIndex].text + rawEntries[numberIndex].text,
                            x: entry.x,
                            y: entry.y
                        });
                        return normalized;
                    }
                }
            }

            normalized.push(entry);
            return normalized;
        }, []);
        const headers = entries.map((item: any) => {
            const match = item.text.match(/^([A-Z]{2}\d{3})(?:\b|\s)/);
            return match ? {
                text: item.text,
                x: item.x,
                y: item.y,
                code: match[1],
                name: item.text.slice(match[0].length).trim()
            } : null;
        }).filter(Boolean);

        headers.forEach((header: any) => {
            const values = entries.filter((item: any) => Math.abs(item.x - header.x) <= 2
                && item.y > header.y
                && /^\d+(?:\s+\d+)*$/.test(item.text))
                .sort((a: any, b: any) => a.y - b.y);
            const rates: string[] = [];
            let digits = "";
            let previousY: number = null;
            const pushDigits = () => {
                if (digits) rates.push(digits);
                digits = "";
                previousY = null;
            };

            values.forEach((item: any) => {
                const tokens = item.text.split(/\s+/);
                if (tokens.length > 1 || tokens[0].length >= 3) {
                    pushDigits();
                    tokens.forEach((token: string) => rates.push(token));
                    return;
                }
                if (previousY !== null && item.y - previousY > 6) pushDigits();
                digits += tokens[0];
                previousY = item.y;
            });
            pushDigits();

            if (rates.length === 24 && rates.every((rate: string) => /^\d{3,5}$/.test(rate))) {
                const numericRates = rates.map(Number);
                const nameEntry = entries.filter((item: any) => Math.abs(item.x - header.x) <= 2
                    && item.y > header.y
                    && !/^\d+(?:\s+\d+)*$/.test(item.text))
                    .sort((a: any, b: any) => a.y - b.y)[0];
                parsed[header.code] = {
                    name: header.name || (nameEntry ? nameEntry.text : header.code),
                    rates: numericRates.concat([numericRates[23], numericRates[23], numericRates[23]])
                };
            }
        });
    }

    private parseRotatedPdfPage(items: any[], parsed: Record<string, { name: string, rates: number[] }>): void {
        const entries = items.map((item: any) => ({
            text: String(item.str),
            x: item.transform[4],
            y: item.transform[5]
        })).filter((item: any) => item.text.trim() !== "").sort((a: any, b: any) => a.x - b.x || a.y - b.y);
        const columns: any[] = [];

        entries.forEach((entry: any) => {
            const column = columns[columns.length - 1];
            if (!column || Math.abs(column.x - entry.x) > 0.2) columns.push({ x: entry.x, entries: [entry] });
            else column.entries.push(entry);
        });

        columns.forEach((column: any) => {
            const columnEntries = column.entries.sort((a: any, b: any) => a.y - b.y);
            const text = columnEntries.map((entry: any) => entry.text).join("");
            const codeMatch = text.match(/([A-Z]{2}\d{3})/);
            if (!codeMatch) return;

            const values: string[] = [];
            columnEntries.forEach((entry: any) => {
                const tokens = entry.text.match(/\d+/g) || [];
                if (values.length && tokens.length && (values[values.length - 1].length < 3 || tokens[0].length < 3)) {
                    values[values.length - 1] += tokens.shift();
                }
                values.push.apply(values, tokens);
            });

            const codeNumber = String(parseInt(codeMatch[1].slice(2), 10));
            while (values.length && String(parseInt(values[0], 10)) === codeNumber) values.shift();
            if (values.length !== 22 && values.length !== 24) return;

            const numericRates = values.map(Number);
            const name = text.slice((codeMatch.index || 0) + codeMatch[1].length).split(/\d/)[0].replace(/\s+/g, " ").trim();
            parsed[codeMatch[1]] = {
                name: name || codeMatch[1],
                rates: values.length === 24
                    ? numericRates.concat([numericRates[23], numericRates[23], numericRates[23]])
                    : numericRates.concat([numericRates[21], numericRates[21], numericRates[21], numericRates[21], numericRates[21]])
            };
        });
    }

    private mergePdfRates(): void {
        const withKeys = Object.keys(this.withDependantsRates);
        const withoutKeys = Object.keys(this.withoutDependantsRates);
        if (!withKeys.length || !withoutKeys.length) return;
        const allowance: Record<string, number[]> = {};
        const areas: any[] = [];
        const mhas: Record<string, boolean> = {};
        withKeys.concat(withoutKeys).forEach((mha) => mhas[mha] = true);
        Object.keys(mhas).forEach((mha) => {
            const withRates = this.withDependantsRates[mha];
            const withoutRates = this.withoutDependantsRates[mha];
            allowance[mha] = ((withRates ? withRates.rates : new Array(27).fill(null)) as any)
                .concat(withoutRates ? withoutRates.rates : new Array(27).fill(null));
            areas.push({ value: mha, name: (withRates || withoutRates).name });
        });
        if (withKeys.length !== withoutKeys.length) this.vm().saveStatus("One or more MHAs appear in only one source PDF and are retained with unavailable rates.");
        this.vm().housingAllowanceData(allowance);
        this.vm().militaryHousingAreasData(areas);
    }

    private resolvePaygradeColumns(header: any[]): number[] {
        const columns: number[] = [];
        BAH_GRADE_KEYS.forEach(function () { columns.push(undefined); });
        header.forEach(function (cell: any, index: number) {
            const raw = String(cell || "").trim().toUpperCase().replace(/\s+/g, " ");
            const compact = raw.replace(/-/g, "");
            let key = BAH_HEADER_KEYS[raw] || BAH_HEADER_KEYS[raw.replace(/ /g, "-")];
            if (!key) {
                const match = compact.match(/^([OWE])(\d+)(E?)$/);
                if (match) key = match[1] + (match[2].length === 1 ? "0" + match[2] : match[2]) + match[3];
            }
            const gradeIndex = BAH_GRADE_KEYS.indexOf(key);
            if (gradeIndex >= 0) columns[gradeIndex] = index;
        });
        if (columns.filter(function (column) { return column !== undefined; }).length === 0) {
            BAH_GRADE_KEYS.forEach(function (key, index) { columns[index] = index + 2; });
        }
        return columns;
    }

    private backfillMissingRates(housingAllowance: Record<string, number[]>): void {
        Object.keys(housingAllowance).forEach(function (mha) {
            const rates = housingAllowance[mha];
            for (let start = 0; start < 54; start += 27) {
                let last = 0;
                for (let index = start; index < start + 27; index++) {
                    if (rates[index] > 0) last = rates[index];
                    else if (last > 0) rates[index] = last;
                }
                last = 0;
                for (let index = start + 26; index >= start; index--) {
                    if (rates[index] > 0) last = rates[index];
                    else if (last > 0) rates[index] = last;
                }
            }
        });
    }

    public generateJson(): void {
        const vm = this.vm();
        const year = parseInt(vm.bahRateYear(), 10);
        if (!Object.keys(this.withDependantsRates).length || !Object.keys(this.withoutDependantsRates).length) {
            vm.saveStatus("Upload both annual BAH PDFs before generating JSON.");
            return;
        }
        if (year < 2000 || year > 2100) {
            vm.saveStatus("Enter the BAH rate year before generating JSON.");
            return;
        }
        const output = {
            bahRateYear: year,
            housingAllowance: vm.housingAllowanceData() || {},
            militaryHousingAreas: vm.militaryHousingAreasData() || [],
        };
        vm.generatedJson(output);
        const preview = JSON.stringify(output, null, 2);
        vm.jsonPreview(preview.length > 50000 ? preview.substring(0, 50000) + "\n\n... (truncated for preview)" : preview);
    }

    public save(): void {
        const vm = this.vm();
        let json = vm.generatedJson();
        if (!json) {
            this.generateJson();
            json = vm.generatedJson();
        }
        if (json && this.caller && typeof this.caller.save === "function") this.caller.save(json);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryBahCalculator_template.ts